<template>
  <div v-if="application.applicants.length">

    <div v-for="(applicant, index) in application.applicants" :key="index"
         class="mb-4">
      <h4 class="tab__content__title">{{ $lang.app.APPLICANT_INFORMATION }}</h4>

      <template v-if="applicant.user?.userInfo?.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')">

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.SURNAME }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.person?.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NAME }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.person?.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.person?.patronymic }}</span>
        </div>

      </template>

      <template v-if="applicant.user?.userInfo?.type === userTypesGetValueByKey('LEGAL_ENTITY')">

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_NAME_KG }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.organization?.nameKg }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_SURNAME }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.organization?.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_NAME }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.organization?.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_PATRONYMIC }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.organization?.patronymic }}</span>
        </div>

      </template>

      <template v-if="applicant.user?.userInfo?.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')">

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.SURNAME }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.individualEnterprise?.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NAME }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.individualEnterprise?.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.individualEnterprise?.patronymic }}</span>
        </div>

      </template>

      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PHONE }}</span>
        <span class="stack__value">{{ applicant.user?.userInfo?.contactDetail?.phone }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.EMAIL }}</span>
        <span class="stack__value">{{ applicant.user?.userInfo?.contactDetail?.email }}</span>
      </div>

      <div v-for="(certifyingDocument, index) in applicant.certifyingDocuments" :key="index" class="my-4">

        <h4 class="tab__content__title">{{ $lang.app.CERTIFYING_ESTABLISHING_DOCUMENTS }}</h4>

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.TYPE }}</span>
          <span class="stack__value">{{ $lang.app[certifyingDocumentTypesGetLabelRefByValue(certifyingDocument.type)] }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.DENOMINATION }}</span>
          <span class="stack__value">{{ certifyingDocument.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NUMBER }}</span>
          <span class="stack__value">{{ certifyingDocument.number }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.DATE }}</span>
          <span class="stack__value">{{ $moment(certifyingDocument.docDate).format("DD.MM.YYYY") }}</span>
        </div>
        <div v-if="certifyingDocument.file" class="stack__list">
          <span class="stack__label">{{ $lang.app.FILE }}</span>
          <span class="stack__value cursor-pointer font-medium text-blue-600"
                @click="$emitter.emit('open-employee-application-pdf-file', certifyingDocument.file)">{{ certifyingDocument.file.filename }}</span>
        </div>

      </div>

    </div>

  </div>
</template>
<script>
import {
  getValueByKey as userTypesGetValueByKey,
} from "../../../helpers/constants/userTypes";
import {
  getLabelRefByValue as certifyingDocumentTypesGetLabelRefByValue,
} from "../../../helpers/constants/certifyingDocumentTypes";

export default {
  props: {
    application: Object
  },
  methods: {
    userTypesGetValueByKey,
    certifyingDocumentTypesGetLabelRefByValue,
  }
}
</script>